import type { RangeSpanT } from '../../../../../common/types/types';
import { TEMPORAL_SCOPE } from '../../../../../modernization-common/relationships/constants';
import type { TemporalScopeT } from '../../../../../modernization-common/relationships/types/relationship';
export const getInitialTemporalScope = (span?: RangeSpanT): TemporalScopeT => !span || span.start === span.end ? TEMPORAL_SCOPE.INSTANT : TEMPORAL_SCOPE.INTERVAL;
type FrameRangeErrors = {
  startError: string | undefined;
  endError: string | undefined;
};
const START_FRAME_REQUIRED_ERROR = 'Start frame is required';
const START_FRAME_OUT_OF_RANGE_ERROR = 'Start frame is outside the video length';
const END_FRAME_REQUIRED_ERROR = 'End frame is required';
const END_FRAME_OUT_OF_RANGE_ERROR = 'End frame is outside the video length';
const END_FRAME_BEFORE_START_ERROR = 'End frame must be greater than start frame';
export const validateFrameRange = (startFrame: number | undefined, endFrame: number | undefined, temporalScope: TemporalScopeT, frameCount: number): FrameRangeErrors => {
  const isInterval = temporalScope === TEMPORAL_SCOPE.INTERVAL;
  const maxFrameIndex = Math.max(frameCount - 1, 0);
  const startOutOfRange = startFrame !== undefined && (startFrame < 0 || startFrame > maxFrameIndex);
  const endOutOfRange = isInterval && endFrame !== undefined && (endFrame < 0 || endFrame > maxFrameIndex);
  const endBeforeStart = isInterval && startFrame !== undefined && endFrame !== undefined && endFrame < startFrame;
  let startError: string | undefined;
  if (startFrame === undefined) {
    startError = START_FRAME_REQUIRED_ERROR;
  } else if (startOutOfRange) {
    startError = START_FRAME_OUT_OF_RANGE_ERROR;
  }
  let endError: string | undefined;
  if (isInterval && endFrame === undefined) {
    endError = END_FRAME_REQUIRED_ERROR;
  } else if (endOutOfRange) {
    endError = END_FRAME_OUT_OF_RANGE_ERROR;
  } else if (endBeforeStart) {
    endError = END_FRAME_BEFORE_START_ERROR;
  }
  return {
    startError,
    endError
  };
};